module.exports = __webpack_public_path__ + "img/background-portrait.4154c192.svg";